export const FORKHIRE_GLOBAL_CANDIDATE_VISIBLE_STAGES = [
  'applied',
  'reviewed',
  'ai_reviewed',
  'shortlisted',
  'shortlisting',
  'interviewed',
  'second_interview',
  'f2f_interview',
  'offering',
  'signing_contract',
  'hired',
] as const;

const GLOBAL_CANDIDATE_VISIBLE_STAGE_SET = new Set<string>(FORKHIRE_GLOBAL_CANDIDATE_VISIBLE_STAGES);
const GLOBAL_CANDIDATE_TERMINAL_STATUS_SET = new Set<string>([
  'rejected',
  'withdrawn',
  'archived',
]);

export type CandidateVisibilityApplication = {
  stage?: string | null;
  status?: string | null;
};

type CandidateWithVisibleApplications = {
  applications: CandidateVisibilityApplication[];
};

function normalizeStageOrStatus(value: string | null | undefined) {
  return (value ?? '').trim().toLowerCase();
}

export function isForkHireGlobalCandidateVisible(application: CandidateVisibilityApplication) {
  const stage = normalizeStageOrStatus(application.stage);
  const status = normalizeStageOrStatus(application.status);

  if (!GLOBAL_CANDIDATE_VISIBLE_STAGE_SET.has(stage)) return false;
  if (GLOBAL_CANDIDATE_TERMINAL_STATUS_SET.has(status)) return false;

  return true;
}

export function countForkHireGlobalCandidateApplications(
  candidates: CandidateWithVisibleApplications[] | undefined,
) {
  return candidates?.reduce(
    (total, candidate) => total + candidate.applications.filter(isForkHireGlobalCandidateVisible).length,
    0,
  );
}
